var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { gql, useMutation } from '@apollo/client';
import { useIsDynamicBooleanEnabled } from '../../DynamicValues/hook';
import { DYNAMIC_VALUES_NAME } from '../../DynamicValues';
export var CREATE_SELF_SERVE_LEAD_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation createSelfServeLead(\n    $firstName: String!\n    $lastName: String!\n    $email: String!\n    $phoneNumber: String!\n    $countryCode: String!\n    $companyName: String!\n    $companySize: String!\n  ) {\n    createSelfServeLead(\n      firstName: $firstName\n      lastName: $lastName\n      email: $email\n      phoneNumber: $phoneNumber\n      countryCode: $countryCode\n      companyName: $companyName\n      companySize: $companySize\n    ) {\n      leadId\n    }\n  }\n"], ["\n  mutation createSelfServeLead(\n    $firstName: String!\n    $lastName: String!\n    $email: String!\n    $phoneNumber: String!\n    $countryCode: String!\n    $companyName: String!\n    $companySize: String!\n  ) {\n    createSelfServeLead(\n      firstName: $firstName\n      lastName: $lastName\n      email: $email\n      phoneNumber: $phoneNumber\n      countryCode: $countryCode\n      companyName: $companyName\n      companySize: $companySize\n    ) {\n      leadId\n    }\n  }\n"])));
export var hasRequiredFields = function (leadInfo) {
    return (!!leadInfo.lastName &&
        !!leadInfo.companyName &&
        !!leadInfo.email &&
        !!leadInfo.phoneNumber);
};
export var useCreateSelfServeLeadMutation = function (leadInfo, options) {
    var isSelfServeLeadEnabled = useIsDynamicBooleanEnabled(DYNAMIC_VALUES_NAME.ddfwSelfServeLead);
    var _a = __read(useMutation(CREATE_SELF_SERVE_LEAD_MUTATION, __assign({ variables: {
            firstName: leadInfo.firstName,
            lastName: leadInfo.lastName,
            email: leadInfo.email,
            phoneNumber: leadInfo.phoneNumber,
            countryCode: leadInfo.countryCode,
            companyName: leadInfo.companyName,
            companySize: leadInfo.companySize,
        }, fetchPolicy: 'network-only' }, options)), 1), createSelfServeLead = _a[0];
    return {
        createLead: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(isSelfServeLeadEnabled && hasRequiredFields(leadInfo))) return [3 /*break*/, 2];
                        return [4 /*yield*/, createSelfServeLead()];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                    case 2: return [2 /*return*/, null];
                }
            });
        }); },
    };
};
var templateObject_1;
